import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { useTexts } from "./texts.js";
import { IconButton } from "./ui.js";
/**
 * Modal sheet (native <dialog>: focus trap + Esc). "side" slides in from the
 * right for quick edits next to a list; "center" is a large dialog in the
 * middle of the screen for a task done step by step (rule flow).
 */
export function SideSheet({ open, onClose, title, subtitle, children, footer, width = 620, placement = "side", }) {
    const ref = useRef(null);
    const t = useTexts();
    useEffect(() => {
        const d = ref.current;
        if (!d)
            return;
        if (open && !d.open)
            d.showModal();
        if (!open && d.open)
            d.close();
    }, [open]);
    return (_jsx("dialog", { ref: ref, onClose: onClose, onCancel: (e) => {
            e.preventDefault();
            onClose();
        }, onMouseDown: (e) => {
            if (e.target === ref.current)
                onClose();
        }, "aria-label": title, className: placement === "center"
            ? "anim-pop m-auto h-[min(92dvh,1040px)] max-h-[92dvh] max-w-[calc(100vw-2rem)] overflow-hidden rounded-[24px] bg-surface p-0 text-fg shadow-2xl backdrop:bg-slate-900/40 backdrop:backdrop-blur-[2px]"
            : "anim-slide-in m-0 ml-auto h-dvh max-h-dvh max-w-full overflow-hidden rounded-l-[20px] bg-surface p-0 text-fg shadow-2xl backdrop:bg-slate-900/30", style: { width }, children: open && (_jsxs("div", { className: "flex h-full flex-col", children: [_jsxs("header", { className: "flex items-start gap-3 border-b border-line/70 px-5 py-3.5", children: [_jsxs("div", { className: "min-w-0 flex-1", children: [_jsx("h2", { className: "text-base font-semibold", children: title }), subtitle && _jsx("div", { className: "mt-0.5 text-xs text-muted", children: subtitle })] }), _jsx(IconButton, { icon: "x", label: t.close, onClick: onClose })] }), _jsx("div", { className: "scroll-thin min-h-0 flex-1 overflow-y-auto", children: children }), footer && _jsx("footer", { className: "border-t border-line/70 bg-surface-2/60 px-5 py-3", children: footer })] })) }));
}
